import * as React from "react";
import styled, { css } from "styled-components";
import Stack from "components/common/Stack";
import Text from "components/common/Text";
import Tooltip from "components/common/Tooltip";
import NumberUtils from "util/NumberUtils";
import { formatNumber, formatReadableNumber } from "util/NumberFormatting";
import { useDataLakeIcebergStreamMetrics } from "data-lake/hooks/useDataLakeIcebergMetrics";
const MutedText = styled(Text)(
  ({ theme }) => css`
    color: ${theme.colors.gray[60]};
  `
);
const compactCount = (value) => formatReadableNumber(value).toUpperCase();
const plural = (value, unit) => `${unit}${value === 1 ? "" : "s"}`;
const exactCount = (records, files) => `${formatNumber(records)} ${plural(records, "record")}, ${formatNumber(files)} ${plural(files, "file")}`;
const RetrievableSizeCell = ({ bytes = 0, records = 0, files = 0, isLoading = false }) => {
  if (isLoading) {
    return /* @__PURE__ */ React.createElement("span", null, "\u2013");
  }
  return /* @__PURE__ */ React.createElement(Stack, { gap: 2 }, /* @__PURE__ */ React.createElement("span", null, NumberUtils.formatDecimalBytes(bytes)), /* @__PURE__ */ React.createElement(Tooltip, { label: exactCount(records, files), withArrow: true }, /* @__PURE__ */ React.createElement("span", null, /* @__PURE__ */ React.createElement(MutedText, { size: "sm" }, `${compactCount(records)} ${plural(records, "record")} \xB7 ${compactCount(files)} ${plural(files, "file")}`))));
};
export const DataLakeStreamRetrievableSizeCell = ({ streamId }) => {
  const { metricsByStreamId, isLoading } = useDataLakeIcebergStreamMetrics([streamId]);
  const metrics = metricsByStreamId.get(streamId);
  return /* @__PURE__ */ React.createElement(
    RetrievableSizeCell,
    {
      bytes: metrics == null ? void 0 : metrics.bytes,
      records: metrics == null ? void 0 : metrics.records,
      files: metrics == null ? void 0 : metrics.files,
      isLoading
    }
  );
};
export default RetrievableSizeCell;
